<template>
  <KTCodePreview v-bind:title="'Danh sách các Campaign POSM'">
    <template v-slot:toolbar>
      <b-row>
        <b-dropdown
          size="sm"
          id="dropdown-1"
          v-if="checkPermissions(['CAMPAIGN_EXCEL_EXPORT'])"
        >
          <template slot="button-content">
            <i style="font-size: 1rem" class="fas fa-cog"></i>
            <span class="font-weight-bolder">Thao tác</span>
          </template>
          <b-dropdown-item @click="showExportExcelModalClickHandler">
            <span>
              <i style="font-size: 1rem" class="far fa-file-excel"></i>
              &nbsp; Xuất Excel</span
            >
          </b-dropdown-item>
        </b-dropdown>
        <router-link
          :to="{
            name: 'posm-form-campaigns-add',
          }"
          v-if="checkPermission('CAMPAIGN_INSERT')"
        >
          <button
            type="button"
            class="btn btn-sm font-weight-bolder btn-primary ml-2"
          >
            <i style="font-size: 1rem" class="flaticon2-add-1 btn-add"></i>
            Tạo mới
          </button>
        </router-link>
      </b-row>
    </template>
    <template v-slot:preview>
      <div>
        <b-col cols="12" class="py-8">
          <ExportExcelModal
            :show="showExportExcelModal"
            @update-show="updateModalState"
          />
          <b-row class="mb-5">
            <b-col md="3">
              <div class="search-col">
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="filterParams.fromDate"
                ></date-picker>
                <span class="ml-1 mr-1"></span>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="filterParams.toDate"
                ></date-picker>
              </div>
            </b-col>
            <b-col md="3">
              <b-form-input
                v-model.trim="filterParams.campaignName"
                type="text"
                placeholder="Tên Campaign"
                size="sm"
                debounce="500"
                v-on:keyup.enter="onFilter()"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <b-form-select
                value-field="id"
                text-field="name"
                v-model="filterParams.status"
                :options="statusOptions"
                size="sm"
              >
                <template #first>
                  <b-form-select-option :value="null"
                    >-- Trạng thái --</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-col>
            <b-col md="2">
              <b-button
                variant="primary"
                size="sm"
                class="btn font-weight-bold btn-filter"
                @click="onFilter()"
                :disabled="loading"
                >Lọc</b-button
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-table
                bordered
                :items="campaigns"
                :fields="fields"
                class="table-vertical-center"
                :busy="loading"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Đang tải...</strong>
                  </div>
                </template>

                <template #cell(isActive)="row">
                  <span
                    class="text-center"
                    :class="getStatusClass(row.item.isActive)"
                  >
                    {{ getStatusLabel(row.item.isActive) }}
                  </span>
                </template>
                <template #cell(actions)="row">
                  <div class="d-flex justify-content-center">
                    <b-dropdown size="sm" id="dropdown-left" no-caret right>
                      <template slot="button-content">
                        <i
                          style="font-size: 1rem; padding-right: 0px"
                          class="flaticon2-settings"
                        ></i>
                      </template>
                      <b-dropdown-item
                        @click="editCampaignHandler(row)"
                        v-if="checkPermission('CAMPAIGN_UPDATE')"
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i style="font-size: 1rem" class="flaticon2-pen"></i>
                          &nbsp; Chỉnh sửa
                        </span>
                      </b-dropdown-item>

                      <b-dropdown-item
                        v-if="checkPermission('CAMPAIGN_UPDATE')"
                        @click="
                          toggleCampaignStatus(row.item.id, row.item.isActive)
                        "
                      >
                        <span :style="statusStyle(row.item.isActive)">
                          <i
                            :class="statusIcon(row.item.isActive)"
                            class="mr-2"
                            style="font-size: 1rem; color: inherit"
                          />
                          {{ statusLabel(row.item.isActive) }}
                        </span>
                      </b-dropdown-item>

                      <b-dropdown-item
                        @click="deleteCampaignHandler(row)"
                        v-if="checkPermission('CAMPAIGN_DELETE')"
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem; color: #d33"
                            class="flaticon2-rubbish-bin-delete-button"
                          ></i>
                          &nbsp; Xóa
                        </span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
              <b-row>
                <b-col>
                  <p class="mt-3 text-dark font-weight-bold">
                    Tổng: {{ totalItems }}
                  </p>
                </b-col>
                <b-col>
                  <BPaginationNavCustom
                    :number-of-pages="totalPages || 1"
                    :current-page="currentPage || 1"
                    :total-page="totalPages || 1"
                    :link-params="{}"
                    @page-change="onPageChange"
                  >
                  </BPaginationNavCustom>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-card no-body class="full-width"></b-card>
    </template>
  </KTCodePreview>
</template>
<style scoped lang="scss">
@import '@/assets/sass/components/_variables.bootstrap.scss';

.add-btn {
  font-size: $font-size-base;
}

.btn-filter {
  width: 90px;
}

.search-col {
  display: flex;
  align-items: center;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.8em;
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { fields } from '@/view/pages/posm/campaign/table-setup';
import CampaignTableData from '@/view/pages/posm/campaign/models/CampaignTableData';
import ApiService from '@/core/services/api.service';
import { cmdUrl } from '@/utils/apiUrl';
import {
  DP_CONFIG,
  formatDate,
  getRemainingDays,
  getSubtractDate,
} from '@/utils/date';
import { handleError, makeToastFaile, makeToastSuccess } from '@/utils/common';
import { DATETIME_FORMAT } from '@/utils/constants';
import moment from 'moment/moment';
import ExportExcelModal from '@/view/components/posm/campaign/ExportExcelModal.vue';
import localData from '@/utils/saveDataToLocal';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { PROMOTION_STATUS } from '@/utils/enum';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  components: {
    KTCodePreview,
    ExportExcelModal,
    BPaginationNavCustom,
  },
  data() {
    return {
      PROMOTION_STATUS,
      fields,
      campaigns: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 1,
      loading: false,
      showExportExcelModal: false,
      apiParams: {
        page: 1,
        perPage: 5,
      },
      filterParams: {
        fromDate: getSubtractDate(30),
        toDate: null,
        campaignName: null,
        status: null,
      },
      dpConfigs: DP_CONFIG,
      statusOptions: [
        {
          id: PROMOTION_STATUS.ACTIVE,
          name: 'Hoạt động',
        },
        {
          id: PROMOTION_STATUS.INACTIVE,
          name: 'Ngừng hoạt động',
        },
      ],
    };
  },

  methods: {
    getStatusClass(status) {
      return status === this.PROMOTION_STATUS.ACTIVE
        ? 'label font-weight-bold label-lg label-light-success label-inline'
        : 'label font-weight-bold label-lg label-light-danger label-inline';
    },
    getStatusLabel(status) {
      return status === this.PROMOTION_STATUS.ACTIVE
        ? 'Hoạt động'
        : 'Ngừng hoạt động';
    },

    statusStyle(isActive) {
      return {
        fontSize: '12px',
        color: isActive === this.PROMOTION_STATUS.ACTIVE ? '#d33' : '#28a745',
      };
    },

    statusIcon(isActive) {
      return isActive === this.PROMOTION_STATUS.ACTIVE
        ? 'fas fa-lock'
        : 'fas fa-unlock';
    },
    statusLabel(isActive) {
      return isActive === this.PROMOTION_STATUS.ACTIVE
        ? 'Vô hiệu hóa'
        : 'Kích hoạt';
    },
    async fetchCampaigns(params) {
      try {
        this.loading = true;

        const requestParams = params || { ...this.apiParams };

        const { campaignName, fromDate, toDate, status } = this.filterParams;

        if (campaignName && campaignName.trim()) {
          requestParams.campaignName = campaignName.trim();
        }

        if (fromDate) {
          requestParams.fromDate = fromDate;
        }

        if (toDate) {
          requestParams.toDate = toDate;
        }

        if (status !== null) {
          requestParams.status = status;
        }

        const { data } = await ApiService.query(cmdUrl.Campaign.root, {
          params: requestParams,
        });

        const responseData = data.data;

        this.campaigns = responseData.result.map((item) => {
          const now = moment().format(DATETIME_FORMAT);
          const formattedEndDate = formatDate(item.endDate, DATETIME_FORMAT);
          const remainingDays = getRemainingDays(now, formattedEndDate);

          return new CampaignTableData(
            item.id,
            item.name,
            formatDate(item.startDate, DATETIME_FORMAT),
            formatDate(item.endDate, DATETIME_FORMAT),
            remainingDays,
            item.isActive,
          );
        });

        this.totalItems = responseData.totalItems;
        this.totalPages = responseData.totalPages;
        this.currentPage = responseData.currentPage;

        this.apiParams.page = this.currentPage;
      } catch (err) {
        makeToastFaile(err.message);
        this.campaigns = [];
        this.totalItems = 0;
        this.totalPages = 1;
        this.currentPage = 1;
      } finally {
        this.loading = false;
      }
    },

    async onFilter() {
      if (this.loading) return;
      this.currentPage = 1;
      this.apiParams.page = 1;
      await this.fetchCampaigns();
    },

    async onPageChange(page) {
      if (this.loading) return;
      this.currentPage = page;
      this.apiParams.page = page;
      await this.fetchCampaigns();
    },

    editCampaignHandler(row) {
      const id = row.item.id;
      this.$router.push({ name: 'posm-form-campaigns-edit', params: { id } });
    },
    deleteCampaignHandler(row) {
      const id = row.item.id;
      const confirmDelete = confirm('Bạn có chắc chắn muốn xóa campaign này?');

      if (!confirmDelete) {
        return;
      }
      ApiService.delete(`${cmdUrl.Campaign.root}/${id}`)
        .then(() => {
          this.fetchCampaigns();
        })
        .catch((err) => {
          makeToastFaile(err.message);
        });
    },

    async toggleCampaignStatus(campaignId, currentStatus) {
      try {
        const newStatus =
          currentStatus === PROMOTION_STATUS.ACTIVE
            ? PROMOTION_STATUS.INACTIVE
            : PROMOTION_STATUS.ACTIVE;

        const statusText =
          newStatus === PROMOTION_STATUS.ACTIVE ? 'kích hoạt' : 'vô hiệu hóa';

        if (!confirm(`Bạn có chắc chắn muốn ${statusText} campaign này?`))
          return;

        await ApiService.put(`${cmdUrl.Campaign.root}/${campaignId}`, {
          isActive: newStatus,
        });

        const campaign = this.campaigns.find((item) => item.id === campaignId);
        if (campaign) campaign.isActive = newStatus;

        makeToastSuccess(`Campaign đã ${statusText} thành công`);
      } catch (error) {
        handleError(error, 'Có lỗi xảy ra khi cập nhật trạng thái campaign');
      }
    },

    showExportExcelModalClickHandler() {
      this.showExportExcelModal = true;
    },
    updateModalState(childComponentVal) {
      this.showExportExcelModal = childComponentVal;
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    checkPermissions: function (conditions) {
      return localData.checkPermissions(conditions);
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Quản lý Campaign' }]);
    this.fetchCampaigns();
  },
};
</script>
